module.exports = __webpack_public_path__ + "img/logo.a577401a.svg";